import { isEqual, uniqWith } from "lodash";
import {
    createReducer,
    createNamespacer,
} from "../../commons/js/utils/reducer";

const initialState = {
    newPackages: {
        list: [],
        loading: false,
        error: "",
        count: 51,
    },
    shopPackages: {
        list: [],
        loading: false,
        error: "",
        count: 51,
    },
    completedPackages: {
        list: [],
        loading: false,
        error: "",
        count: 51,
    },
    activeType: "miscfab",
};

const miscFabMaterial = createNamespacer("MISCFAB_MATERIAL");

const miscFabMaterialReducer = createReducer(initialState, {
    [miscFabMaterial("SET_PACKAGES_LOADING")]: (state, action) => {
        return {
            ...state,
            newPackages: {
                ...state.newPackages,
                loading: action.payload.value,
            },
        };
    },
    [miscFabMaterial("SET_PACKAGES")]: (state, action) => {
        let newPackagesList = [
            ...state.newPackages.list,
            ...action.payload.value,
        ];
        const activeFacility = JSON.parse(localStorage.getItem(`${state.activeType}Facility`));
        const activeFacilityId = activeFacility ? activeFacility.value : null;
        let finalPackagesList =
            action.payload.type === state.activeType &&
            action.payload.facilityId === activeFacilityId
                ? newPackagesList
                : [];
        return {
            ...state,
            newPackages: {
                ...state.newPackages,
                list: uniqWith(finalPackagesList, isEqual),
                count: action.payload.count,
            },
        };
    },
    [miscFabMaterial("SET_SHOP_PACKAGES_LOADING")]: (state, action) => {
        return {
            ...state,
            shopPackages: {
                ...state.shopPackages,
                loading: action.payload.value,
            },
        };
    },
    [miscFabMaterial("SET_SHOP_PACKAGES")]: (state, action) => {
        let shopPackagesList = [
            ...state.shopPackages.list,
            ...action.payload.value,
        ];
        const activeFacility = JSON.parse(localStorage.getItem(`${state.activeType}Facility`));
        const activeFacilityId = activeFacility ? activeFacility.value : null;
        let finalShopPackagesList =
            action.payload.type === state.activeType &&
            action.payload.facilityId === activeFacilityId
                ? shopPackagesList
                : [];
        return {
            ...state,
            shopPackages: {
                ...state.shopPackages,
                list: uniqWith(finalShopPackagesList, isEqual),
                count: action.payload.count,
            },
        };
    },
    [miscFabMaterial("SET_COMPLETED_PACKAGES_LOADING")]: (state, action) => {
        return {
            ...state,
            completedPackages: {
                ...state.completedPackages,
                loading: action.payload.value,
            },
        };
    },
    [miscFabMaterial("SET_COMPLETED_PACKAGES")]: (state, action) => {
        let completedPackagesList = [
            ...state.completedPackages.list,
            ...action.payload.value,
        ];
        const activeFacility = JSON.parse(localStorage.getItem(`${state.activeType}Facility`));
        const activeFacilityId = activeFacility ? activeFacility.value : null;
        let finalCompletedPackagesList =
            action.payload.type === state.activeType &&
            action.payload.facilityId === activeFacilityId
                ? completedPackagesList
                : [];
        return {
            ...state,
            completedPackages: {
                ...state.completedPackages,
                list: uniqWith(finalCompletedPackagesList, isEqual),
                count: action.payload.count,
            },
        };
    },
    [miscFabMaterial("CLEAR")]: (state, action) => {
        return {
            ...initialState,
        }
    },
});

export default miscFabMaterialReducer;
